import React from "react";

import { useGetAllUserVerificationFarmTasks, useGetFarms, useTranslation } from "utils";

import { ErrorBoundary, Flex, Icon, ProgressBar, Tag, Typography } from "components";

import { TaskOverviewDrawer } from "pages/app/farm/components/TaskOverviewDrawer";

export const FileUploadTile = ({
  openFileUploadTasksCount,
  progressBarColors,
  isDrawerOpen,
  onDrawerOpenChange,
}: {
  openFileUploadTasksCount: { completed: number; total: number };
  progressBarColors: { progressColor: string; trailColor: string };
  isDrawerOpen: boolean;
  onDrawerOpenChange: (open: boolean) => void;
}) => {
  const { t } = useTranslation("historicalPracticeDataTableView");
  const { currentFarm } = useGetFarms();
  const {
    data: verificationFarmTasks,
    isLoading: isLoadingVerificationFarmTasks,
    isFetching: isFetchingVerificationFarmTasks,
    refetch: refetchVerificationFarmTasks,
  } = useGetAllUserVerificationFarmTasks(currentFarm?.id);

  return (
    <>
      <Flex
        className="historical-practice-data-table-view-side-panel-file-upload-container"
        vertical
        gap="0.5rem"
        onClick={() => onDrawerOpenChange(true)}
        role="button"
      >
        <Flex gap="0.5rem" justify="space-between" align="center">
          <Typography variant="h5">{t("sidePanel.fileUpload.title")}</Typography>
          <Flex justify="flex-end" align="center">
            <Tag text={t("sidePanel.fileUpload.required")} colour="yellow" className="margin-0" />
            <Icon className="historical-practice-data-table-view-side-panel-file-upload-icon" iconName="tabler/arrow-narrow-right" size="m-light" />
          </Flex>
        </Flex>
        <Typography variant="paragraph-s" className="margin-0">
          {t("sidePanel.fileUpload.description")}
        </Typography>
        <Flex vertical align="flex-end">
          <Typography variant="paragraph-s" bold color="grey-600" className="margin-0">
            {openFileUploadTasksCount.completed}/{openFileUploadTasksCount.total}
          </Typography>
          <ProgressBar
            percent={openFileUploadTasksCount.total > 0 ? Math.round((openFileUploadTasksCount.completed / openFileUploadTasksCount.total) * 100) : 100}
            type="line"
            showInfo={false}
            strokeColor={progressBarColors.progressColor}
            trailColor={progressBarColors.trailColor}
            strokeWidth={4}
          />
        </Flex>
      </Flex>
      <ErrorBoundary>
        <TaskOverviewDrawer
          farmTasks={verificationFarmTasks ?? []}
          visible={isDrawerOpen}
          onClose={() => onDrawerOpenChange(false)}
          onDataChange={refetchVerificationFarmTasks}
          loading={isLoadingVerificationFarmTasks || isFetchingVerificationFarmTasks}
        />
      </ErrorBoundary>
    </>
  );
};
